import React from "react";
import { inject, observer } from "mobx-react";
import ThumbnailEntry from "component/molecules/thumbnailEntry";
import Helper from "helper";
/**
 *
 *
 * @class ThumbnailEntry
 * @extends {React.Component<IThumbnailEntryProps, IthumbnailEntryStates>}
 */
@inject("metadataStore")
@inject("seriesListStore")
@observer
class ThumbnailContainer extends React.Component {
  render() {
    let { metadataStore, seriesListStore, metadataID, ...props } = this.props;
    const numberOfFrames = metadataStore.getNumberOfFrames(metadataID);

    const thumbnailFrame = seriesListStore.getThumbnailFrameNumber(metadataID);
    Helper.Log.Dev("@render : ThumbnailContainer");
    return (
      <ThumbnailEntry
        thumbnailFrame={thumbnailFrame}
        numberOfFrames={numberOfFrames}
        {...props}
      />
    );
  }
}

export default ThumbnailContainer;
